import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import TablePagination from '@material-ui/core/TablePagination';
import { LoadingComponent } from '../../../../utils/newLoader';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from "@material-ui/pickers";


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },

}));

const cellStyle = {
      border: '1px solid black',
      fontSize: '15px',
    };

const screenCode = 'LASTMONTHDEBITREPORT';

export default function  LastMonthDebitReport(props) {
  const [title, setTitle] = useState("Last Month Debit Report");
  const classes = useStyles();
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);
  const [applicableDate, setApplicableDate] = useState(new Date());
  const [lastMonthDebitDetail, setlastMonthDebitDetail] = useState({    
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    applicableMonth: moment(new Date()).format('MM'),
    applicableYear: moment(new Date()).format('YYYY')
  });
  
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routes, setRoutes] = useState();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [lastMonthDebitDetailTableData, setlastMonthDebitDetailTableData] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName: "0",
    applicableMonth: '',
    applicableYear: ''
  })
  const navigate = useNavigate();
  const alert = useAlert();
  const [csvHeaders, SetCsvHeaders] = useState([])
  const componentRef = useRef();
  const [totalDebitAmount, setTotalDebitAmount] = useState(0);
  const [totalleafAmount, setTotalleafAmount] = useState(0);
  const [totalInterestAmount, setTotalInterestAmount] = useState(0);

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    trackPromise(
      getPermission()
    );
    trackPromise(
      getGroupsForDropdown()
    );
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
  }, [lastMonthDebitDetail.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID()
    )
  }, [lastMonthDebitDetail.factoryID]);


  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWLASTMONTHDEBITREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setlastMonthDebitDetail({
      ...lastMonthDebitDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  useEffect(() => {
    setlastMonthDebitDetail((prev) => ({
      ...prev,
    }));
  }, [lastMonthDebitDetail.groupID, lastMonthDebitDetail.factoryID, lastMonthDebitDetail.routeID]);

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(lastMonthDebitDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(lastMonthDebitDetail.factoryID);
    setRoutes(routeList);
  }

  async function GetLastMonthDebitReportDetails() {

    let totaldebit=0;
    let totalleaf=0;
    let totalinterest=0;

    let model = {
          groupID: parseInt(lastMonthDebitDetail.groupID),
          factoryID: parseInt(lastMonthDebitDetail.factoryID),
          routeID: parseInt(lastMonthDebitDetail.routeID),
          applicableMonth: applicableDate ? moment(applicableDate).format('MM') : '',
          applicableYear: applicableDate ? moment(applicableDate).format('YYYY') : ''
        };

    const debitData = await services.GetLastMonthDebitReportDetails(model);
    getSelectedDropdownValuesForReport(lastMonthDebitDetail.groupID, lastMonthDebitDetail.factoryID, lastMonthDebitDetail.routeID);

    if (debitData.statusCode == "Success" && debitData.data != null) {    
      setlastMonthDebitDetailTableData(debitData.data);
       debitData.data.forEach(x => {
        totaldebit = totaldebit + parseFloat(x.debitAmount);
      });
      setTotalDebitAmount(totaldebit);

       debitData.data.forEach(x => {
        totalleaf = totalleaf + parseFloat(x.leafNetWeight);
      });
      setTotalleafAmount(totalleaf);

       debitData.data.forEach(x => {
        totalinterest = totalinterest + parseFloat(x.interestAmount);
      });
      setTotalInterestAmount(totalinterest);

      createDataForExcel(debitData.data);
      if (debitData.data.length == 0) {
        alert.error("No records to display");
      }
    }
    else {
      alert.error(debitData.message);
    }
  }

 
  async function createDataForExcel(array) {

    var res = [];

    if (array != null) {
      array.map(x => {
        var vr = {
          'Reg No': x.registrationNumber,
          'Customer Name': x.customerName,
          'Debit Amount': x.debitAmount,
          'Interest Amount': x.interestAmount,
        }
        res.push(vr);
      });
      res.push({});
      var vr = {
          'Reg No':'Total',
          'Customer Name':'',
          'Debit Amount':totalDebitAmount,
          'Interest Amount':totalInterestAmount,
      }
      res.push(vr); 
      var vr = {
        'Reg No': 'Factory :' + selectedSearchValues.factoryName,
        'Customer Name': 'Group :' + selectedSearchValues.groupName,
      }
      res.push(vr);

      var vr = {
        'Route Name': selectedSearchValues.routeName == undefined ? 'Route :' + 'All Routes' : 'Route :' + selectedSearchValues.routeName,
        'Reg No': 'Date : ' + getMonthName(selectedSearchValues.applicableMonth)+ '/' + lastMonthDebitDetail.applicableYear,
      }
      res.push(vr);
    }
    return res;
  }

  async function createFile() {
  var file = await createDataForExcel(lastMonthDebitDetailTableData);
  var monthName = getMonthName(lastMonthDebitDetail.applicableMonth);
  
  var settings = {
    sheetName: 'Last Month Debit Report',
    fileName: 'Last Month Debit Report _' + selectedSearchValues.groupName + '_' + selectedSearchValues.factoryName + '_' + monthName + '_' + lastMonthDebitDetail.applicableYear,
    writeOptions: {}
  }

  let keys = Object.keys(file[0])
  let tempcsvHeaders = csvHeaders;
  keys.map((sitem, i) => {
    tempcsvHeaders.push({ label: sitem, value: sitem })
  })

  let dataA = [
    {
      sheet: 'Last Month Debit Report',
      fileName: 'Last Month Debit Report_' + selectedSearchValues.groupName + '_' + selectedSearchValues.factoryName + '_' + monthName + '_' + lastMonthDebitDetail.applicableYear,
      columns: tempcsvHeaders,
      content: file
    }
  ]

  xlsx(dataA, settings);
}

const getMonthName = (monthNumber) => {
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  return months[parseInt(monthNumber) - 1];
}

  function getSelectedDropdownValuesForReport(groupID, factoryID, routeID) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[groupID],
      factoryName: FactoryList[factoryID],
      routeName: routes[routeID],
      applicableMonth: moment(applicableDate).format('MM'),
      applicableYear: moment(applicableDate).format('YYYY')

    })
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setlastMonthDebitDetail({
      ...lastMonthDebitDetail,
      [e.target.name]: value
    });
    setlastMonthDebitDetailTableData([]);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  const getPageMargins = () => {
    return `@media print {
          @page {
              background-color: white !important;
              layout:A4;      
          }
          body {
              background-color: white !important;
          }
      }`;
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: lastMonthDebitDetail.groupID,
              factoryID: lastMonthDebitDetail.factoryID,
              applicableMonth: moment(applicableDate).format('MM'),
              applicableYear: moment(applicableDate).format('YYYY'),
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                applicableMonth: Yup.string().required('Select a date'),
              })
            }
            onSubmit={() => trackPromise(GetLastMonthDebitReportDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              size='small'
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={lastMonthDebitDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              size='small'
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={lastMonthDebitDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              size='small'
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={lastMonthDebitDetail.routeID}
                              variant="outlined"
                              id="routeID"
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="Applicable Month *"
                                helperText="Select applicable month"
                                value={applicableDate}
                                        onChange={(e) => {
                                            setApplicableDate(e)
                                           
                                        }}
                                maxDate={new Date()}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                          <Grid container justify="flex-end">
                            <Box pr={2}>
                              <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                              >
                                Search
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </CardContent>
                      <br>
                      </br>
                      <br>
                      </br>
                      <Divider />
                      <Box minWidth={1050}>
                        {lastMonthDebitDetailTableData.length > 0 ?
                          <TableContainer >
                            <Table aria-label="simple table">
                              <TableHead>
                                <TableRow style={{ border: "1px solid black" }}>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}>Reg No</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}>Customer Name</TableCell>
                                  {/* <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}>Leaf (Kg)</TableCell> */}
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}> Debit Amount(Rs)</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}> Interest Amount(Rs)</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {lastMonthDebitDetailTableData.slice(page * limit, page * limit + limit).map((data, index) => (
                                  <TableRow style={{ border: "1px solid black" }} key={index}>
                                    <TableCell component="th" scope="row" align="center" style={cellStyle}> {data.registrationNumber}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={cellStyle}> {data.customerName}</TableCell>
                                    {/* <TableCell component="th" scope="row" align="right" style={cellStyle}>{data.leafNetWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell> */}
                                    <TableCell component="th" scope="row" align="right" style={cellStyle}>{data.debitAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell component="th" scope="row" align="right" style={cellStyle}> {data.interestAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                              <TableRow>
                                <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black", borderRight: "none", width: '20%' }}>Total</TableCell>
                                <TableCell align="left" style={{ borderTop: "1px solid black", borderBottom: "1px solid black", borderLeft: "none", width: '20%' }}></TableCell>
                                {/* <TableCell align="right" style={{ border: "1px solid black", width: '20%' }}><b>{totalleafAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell> */}
                                <TableCell align="right" style={{ border: "1px solid black", width: '20%'  }}><b>{totalDebitAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                <TableCell align="right" style={{ border: "1px solid black", width: '20%' }}><b>{totalInterestAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>          
                              </TableRow>
                            </Table>
                            <TablePagination
                              component="div"
                              count={lastMonthDebitDetailTableData.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={limit}
                              rowsPerPageOptions={[5, 10, 25]}
                            />
                          </TableContainer> : null}
                      </Box>
                      {lastMonthDebitDetailTableData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                          >
                            EXCEL
                          </Button>

                          <ReactToPrint
                            documentTitle={"Last Month Debit Report_" + selectedSearchValues.groupName + '_' + selectedSearchValues.factoryName + '_' + getMonthName(selectedSearchValues.applicableMonth) + '_' + selectedSearchValues.applicableYear}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                            >
                              PDF
                            </Button>}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />

                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              lastMonthDebitDetailTableData={lastMonthDebitDetailTableData} 
                              searchData={selectedSearchValues}
                              total={totalDebitAmount} 
                              lastMonthDebitDetail={lastMonthDebitDetail}
                              totalleafAmount={totalleafAmount} 
                              totalInterestAmount={totalInterestAmount}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  )
}
